import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.some";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import Vue from 'vue';
import VueRouter from 'vue-router'; // 进度条

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store/index';
import { concat, isNil } from 'lodash';
import { dbGet } from '@/libs/util.db';
var initAuthorityValue = 'store-router-page'; // 路由数据

import { routesInLayout, routesOutLayout, generatorsRoutes } from './routes'; // fix vue-router NavigationDuplicated

var VueRouterPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};

var VueRouterReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
};

Vue.use(VueRouter);
/**
 * @description 创建在 layout 中显示的路由设置
 * @param {Array} routes 动态路由设置
 */

export function createRoutesInLayout() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return [_objectSpread(_objectSpread({}, routesInLayout[0]), {}, {
    children: [].concat(_toConsumableArray(routesInLayout[0].children), _toConsumableArray(routes))
  })];
} //从接口返回的数据中计算出路由

function getRoutes(menuSource) {
  var newTree = generatorsRoutes.filter(function (x) {
    return menuSource.some(function (f) {
      return f.authorityValue == x.meta.authorityValue && f.active || x.meta.authorityValue == initAuthorityValue;
    });
  });
  return newTree;
} // 导出默认db中的路由


export function dbgetRoutes() {
  var routers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  routers = dbGet({
    dbName: 'permission',
    path: 'permission.menu',
    defaultValue: [],
    user: true
  }); // [ 权限 ] 计算权限列表

  var flatMenu = YL.flatTreeToArray({
    data: routers || []
  });
  return {
    framesInRoutes: getRoutes(flatMenu),
    routes: concat(routesInLayout, routesOutLayout)
  };
}

var _dbgetRoutes = dbgetRoutes(),
    routes = _dbgetRoutes.routes,
    framesInRoutes = _dbgetRoutes.framesInRoutes; // 默认的路由


export var constantRoutes = createRoutesInLayout(framesInRoutes).concat(routesOutLayout);
/**
 * @description 创建路由
 * @param {Array} routes 路由设置
 */

var createRouter = function createRouter() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new VueRouter({
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: routes
  });
}; // 导出路由 在 main.js 里使用


var router = createRouter(constantRoutes);
/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var appStoreId, mapStatus, token;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.dispatch('d2admin/page/isLoaded');

          case 2:
            _context.next = 4;
            return store.dispatch('d2admin/size/isLoaded');

          case 4:
            // 进度条
            NProgress.start(); // 关闭搜索面板

            store.commit('d2admin/search/set', false);
            appStoreId = store.getters['d2admin/user/appStoreId']; // 验证当前路由所有的匹配中是否需要有登录验证的

            if (!to.matched.some(function (r) {
              return r.meta.auth;
            })) {
              _context.next = 17;
              break;
            }

            if (!(isNil(appStoreId) || appStoreId == '')) {
              _context.next = 13;
              break;
            }

            mapStatus = [{
              label: '未申请',
              value: 0,
              key: 'settled'
            }, {
              label: '已申请',
              value: 1,
              key: 'resident'
            }, {
              label: '审核通过',
              value: 2,
              key: 'resSucc'
            }, {
              label: '已完善信息',
              value: 3,
              key: 'payment'
            }, {
              label: '已缴纳保证金',
              value: 4,
              key: 'examine'
            }, {
              label: '保证金审核失败',
              value: 5,
              key: 'examineError'
            }, {
              label: '入驻审核未通过',
              value: 7,
              key: 'resError'
            }];
            console.log(to);

            if (mapStatus.some(function (x) {
              return to.name.indexOf(x.key) > -1;
            })) {
              next();
            } else {
              store.dispatch('d2admin/account/logout');
            }

            return _context.abrupt("return");

          case 13:
            // 请根据自身业务需要修改
            //合法路由
            token = YL.cookies.get(process.env.VUE_APP_LOGIN_TOKEN);

            if (token && !isNil(token) && !isNil(appStoreId)) {
              next();
            } else {
              if (!isNil(token) && isNil(appStoreId)) {
                store.dispatch('d2admin/account/logout');
              } // 没有登录的时候跳转到登录界面
              // 携带上登陆成功之后需要跳转的页面完整路径


              next({
                name: 'login',
                query: {
                  redirect: to.fullPath
                }
              }); // https://github.com/d2-projects/d2-admin/issues/138

              NProgress.done();
            }

            _context.next = 18;
            break;

          case 17:
            // 不需要身份校验 直接通过
            next();

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done(); // 多页控制 打开新的页面

  store.dispatch('d2admin/page/open', to); // 更改标题

  YL.title(to.meta.title);
}); //重新设置路由

export function resetRouter() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  router.matcher = createRouter(routes).matcher;
}
export default router;